import React from 'react';

import DataConnector from 'connect/DataConnector';
import {NavStoreRegistry} from 'constants/RegistryConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import NavStore from 'nav/NavStore';
import RegistryActions from 'registry/RegistryActions';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import DeleteOrArchiveRegistryButton from './DeleteOrArchiveRegistryButton';

interface EnhancedProps {
  registry?: NavStoreRegistry | null;
}

export interface BaseDeleteOrArchiveRegistryButtonContainerProps {
  registryId: string;
}

class DeleteOrArchiveRegistryButtonContainerConnector extends DataConnector<
  BaseDeleteOrArchiveRegistryButtonContainerProps,
  EnhancedProps
> {
  override stores = [NavStore];

  enhanceProps(): EnhancedProps {
    return {
      registry: this.navStore().getSource(this.props.registryId) as NavStoreRegistry,
    };
  }
}

/**
 * Hook up DeleteOrArchiveRegistryButton to Flux actions and store
 */
class DeleteOrArchiveRegistryButtonContainer extends React.Component<
  BaseDeleteOrArchiveRegistryButtonContainerProps & EnhancedProps
> {
  override componentDidMount(): void {
    if (!this.props.registry) {
      // Fetch registry if registry not loaded
      FileBrowserActions.fetchSources();
    }
  }

  private handleDelete = (): void => {
    RegistryActions.delete(this.props.registryId);
  };

  override render(): JSX.Element {
    if (!this.props.registry) {
      // Render loading UI if registry not loaded
      return <HorizontalThrobber />;
    }
    return <DeleteOrArchiveRegistryButton onDelete={this.handleDelete} registry={this.props.registry} />;
  }
}

export default DeleteOrArchiveRegistryButtonContainerConnector.connect(
  DeleteOrArchiveRegistryButtonContainer
);
